import storage from '@/services/storage';
import { registerResetFn, resetAllStores } from '@/store/reset';
import { create } from 'zustand';
import { userSession } from '../helpers';

export interface AuthStore {
  isInternal: boolean;
}

const initialState: AuthStore = {
  isInternal: false,
};

export const useAuthStore = create<AuthStore>()(() => ({ ...initialState }));

registerResetFn(() => useAuthStore.setState(initialState));

export const logout = () => {
  storage.clearStorage();
  resetAllStores();
};

export const validateInternal = async () => {
  try {
    const data = await userSession();
    useAuthStore.setState({ isInternal: data != null });
  } catch {
    useAuthStore.setState({ isInternal: false });
  }
};

export const isInternalSelector = (state: AuthStore) => state.isInternal;
